import React, { useState, useContext, useEffect } from "react";
import "../../../styles/casedetails.css";
import { Outlet, Link, useNavigate, Navigate } from "react-router-dom";
import { ShareContext } from "../../../context/ShareContext";
import * as Constants from "../../../constants";
import JisButton from "../../controls/jisButton";
import JisDialog from "../../dialog";
import DynamicIcon from "../../dynamicicon";
import JisDialogForm from "../../formdialog";
import PdfViewer from "../../controls/pdfviewer";

function ViewPayments({ caseId, payments = null, isAction = false }) {
  const navigate = useNavigate();
  const { activePage, token, profile, frequentData, setIsExpired } =
    useContext(ShareContext);

  const [loading, setLoading] = useState(false);
  const [pays, setPays] = useState(payments);
  const [payConfirmed, setPayConfirmed] = useState(false);
  const [pay, setPay] = useState(null);
  const [feeid, setFeeid] = useState(null);
  const [fetchingReceipt, setFetchingReceipt] = useState({});
  const [isPreview, setIsPreview] = useState(false);
  const [previewUrl, setPreviewUrl] = useState("");

  useEffect(() => {
    /* if(payments==null){
               onLoad();
              } */
    console.log("before profile");
    console.log(profile);
  }, [payments]);

  const onLoad = async () => {
    //for account registration
    try {
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/filing/case-details/${caseId}/payments`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = await resp.json();
      if (data.code == 0) {
        setPays(data.payments);
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const onMakePayment = (pay) => {
    navigate(`/payment/${pay.id}`);
  };

  const onVerifyPayment = async (fid, index) => {
    //this to continue the process for cases that looks like it
    setLoading(true);
    setFeeid(fid);
    try {
      const resp = await fetch(
        `${Constants.apiUrl}/payment/payment-verify-both/${fid}`,
        {
          method: "POST",

          headers: {
            "Content-Type": "application/json, text/plain",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = await resp.json();
      setLoading(false);
      console.log(data);
      if (data.code === 0) {
        setPay(data.payreceipt);
        setPayConfirmed(true);
        // get specific index
        const updated = pays.map((pay) =>
          pay.id === fid ? { ...pay, isPaid: true } : pay,
        );
        setPays(updated);
      } else {
        //setErr("We cannot confirm the payment");
        navigate(`/payment/${fid}`);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      // setErr(Constants.serverErr);
      // onMove();
    }
  };

  const fetchReceiptUrl = async (webGuid, paymentId) => {
    setFetchingReceipt((prev) => ({ ...prev, [paymentId]: true }));
    try {
      const resp = await fetch(
        `${Constants.apiUrl}/payment/get-revenue-receipt/${webGuid}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = await resp.json();
      setFetchingReceipt((prev) => ({ ...prev, [paymentId]: false }));

      if (data.code === 0 && data.payreceipt?.receiptUrl) {
        // Update the payment with the fetched receipt URL
        const updated = pays.map((pay) =>
          pay.id === paymentId ? { ...pay, receiptUrl: data.payreceipt?.receiptUrl } : pay,
        );
        setPays(updated);
        // Open the receipt URL in modal
        setPreviewUrl(data.payreceipt?.receiptUrl);
        setIsPreview(true);
      } else if (data.code == -10) {
        setIsExpired(true);
      } else {
        console.error("Failed to fetch receipt URL");
      }
    } catch (error) {
      setFetchingReceipt((prev) => ({ ...prev, [paymentId]: false }));
      console.error(error);
    }
  };

  const handlePreviewDownload = (payment) => {
    // Check if receiptUrl is null, undefined, or empty string
    if (!payment.receiptUrl || payment.receiptUrl.trim() === "") {
      // Fetch the receipt URL from the API
      if (payment.webGuid) {
        fetchReceiptUrl(payment.webGuid, payment.id);
      }
    } else {
      // Open the existing receipt URL in modal
      setPreviewUrl(payment.receiptUrl);
      setIsPreview(true);
    }
  };

  const onRevenueReceipt = () => {
    setPreviewUrl(pay?.receipt);
    setIsPreview(true);
  };

  const onUpload = () => {
    navigate(`/document-upload/${feeid}`);
  };

  const handleJudiciaryReceipt = (paymentId) => {
    setPreviewUrl(`${Constants.baseurl}/receipt/${paymentId}`);
    setIsPreview(true);
  };
  return (
    <div>
      <div className="table">
        <div class="table-header">
          <p>Payments </p>
        </div>
        <div className="table-wrapper">
          <table className="case-details-table full-border">
            <thead>
              <tr>
                <th>Fee Type</th>
                <th>Amount</th>
                <th>Date</th>
                <th>Web Guid</th>
                <th className="col-medium">Payment Status</th>
                <th>Revenue Receipt</th>
                <th>Judiciary Receipt</th>
                <th className="col-action">Action</th>
              </tr>
            </thead>
            <tbody>
              {pays?.map((opt, ind) => (
                <tr key={opt.id}>
                  <td>
                    {" "}
                    {opt.associatedFeeId == null
                      ? Constants.getItemById(
                          frequentData?.feetypes,
                          opt.caseFeeTypeId,
                        )?.description
                      : "Revised Fee"}
                  </td>
                  <td>{opt.fee ? Constants.formatCurrency(opt.fee) : "N/A"}</td>
                  <td>
                    {" "}
                    {opt.createdOn
                      ? Constants.momentDate(opt.createdOn).format(
                          "DD MMM, YYYY",
                        )
                      : "N/A"}
                  </td>
                  <td>{opt.webGuid || "N/A"}</td>
                  <td>{opt.isPaid ? "Paid" : "Unpaid"}</td>
                  <td>
                    {opt.isPaid && opt.webGuid  ? (
                      <JisButton
                        onClick={() => handlePreviewDownload(opt)}
                        variant="plain"
                        disabled={fetchingReceipt[opt.id]}
                      >
                        {fetchingReceipt[opt.id]
                          ? "Loading..."
                          : "Preview/Download"}
                      </JisButton>
                    ) : (
                      "N/A"
                    )}
                  </td>
                  <td>
                    {" "}
                    {opt.isPaid && (
                      <JisButton
                        onClick={() => handleJudiciaryReceipt(opt.id)}
                        variant="plain"
                      >
                        View
                      </JisButton>
                    )}
                  </td>
                  {profile.id == opt.party?.legalCounselId ? (
                    <td>
                      {!opt.isPaid && opt.webGuid == null && (
                        <JisButton onClick={() => onMakePayment(opt)}>
                          Make Payment
                        </JisButton>
                      )}
                      {opt.isPaid == false && opt.webGuid != null && (
                        <JisButton onClick={() => onVerifyPayment(opt.id, ind)}>
                          Sync Payment
                        </JisButton>
                      )}
                    </td>
                  ) : (
                    <td>N/A</td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      {payConfirmed && (
        <JisDialogForm title="Payment" onClose={() => setPayConfirmed(false)}>
          <div class="receipt-section">
            <div class="icons">
              <DynamicIcon iname="done" size={60} />
            </div>

            <h3>Payment Successful</h3>
            <div className="payment-details">
              <div className="row">
                <strong>Payer ID:</strong>
                <span>{pay?.payerId}</span>
              </div>
              <div className="row">
                <strong>Payer Name:</strong>
                <span>{pay?.payerName}</span>
              </div>
              <div className="row">
                <strong>Transaction Number:</strong>
                <span>{pay?.paymentTrans}</span>
              </div>
              <div className="row">
                <strong>Date and Time of Transaction:</strong>
                <span>{Constants.displayDateTime(pay?.paymentDate)}</span>
              </div>
              <div className="row">
                <strong>Receiving HOA Name:</strong>
                <span>{pay?.agencyName}</span>
              </div>
              <div className="row">
                <strong>Payment Details:</strong>
                <span>Success</span>
              </div>

              <div className="row">
                <strong>Bill Reference Number:</strong>
                <span>{pay?.reference}</span>
              </div>
              {/*  <div className="row"><strong>Address:</strong><span>20B, Adeola Estate, Ogba, Lagos</span></div> */}
              <div className="row">
                <strong>Amount:</strong>
                <span>₦ {Constants.formatCurrency(pay?.amountPaid)}</span>
              </div>
              <div className="row">
                <strong>Agency:</strong>
                <span>{pay?.agencyCode}</span>
              </div>
              <div className="row">
                <strong>Revenue Code:</strong>
                <span>{pay?.revenueCode}</span>
              </div>
            </div>
            <div class="receipt-buttons">
              <JisButton>Judiciary Receipt</JisButton>
              <JisButton onClick={onRevenueReceipt}>Revenue Receipt</JisButton>
              <JisButton onClick={onUpload}>Upload Document</JisButton>
            </div>
          </div>
        </JisDialogForm>
      )}
      {isPreview && (
        <JisDialogForm title="Preview" onClose={() => setIsPreview(false)}>
          <div>
            <div style={{ height: "90vh" }}>
              <PdfViewer pdfUrl={previewUrl} />
            </div>
          </div>
        </JisDialogForm>
      )}
    </div>
  );
}

export default ViewPayments;
